import { InputRow } from '../InputRow.jsx';
import { SoilDate } from '../SoilDate.jsx';

export function LimeFieldInputs({ instance }) {
  const rx = instance.lime;

  return (
    <>
      <InputRow name="Lime Quality" value={rx.quality} />
      <InputRow name="Ref Lime Quality" value={rx.referenceQuality} />
      <SoilDate rx={rx} />
    </>
  );
}
